import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

export default function ModalArchivo({ mostrar, onCerrar, onEnviar, enviando, respuesta }) {
  const [archivo, setArchivo] = useState(null);
  const [mensaje, setMensaje] = useState('');

  const cerrar = () => {
    setArchivo(null);
    setMensaje('');
    onCerrar();
  };

  return (
    <Modal show={mostrar} onHide={cerrar}>
      <Modal.Header closeButton>
        <Modal.Title>Adjuntar archivo al chat</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={(e) => e.preventDefault()}>
          <label htmlFor="chat-archivo">Archivo</label>
          <input id="chat-archivo" className="form-control" type="file" onChange={(e) => setArchivo(e.target.files[0] || null)} />
          {archivo && (
            <p className="chat-archivo-info">
              {archivo.name} · {Math.round(archivo.size / 1024)} KB
            </p>
          )}
          <label htmlFor="chat-archivo-mensaje" style={{ marginTop: '10px' }}>
            Mensaje
          </label>
          <textarea
            id="chat-archivo-mensaje"
            className="form-control"
            placeholder="Mensaje (opcional)"
            value={mensaje}
            onChange={(e) => setMensaje(e.target.value)}
          />
          {respuesta && <p className="chat-archivo-respuesta">{respuesta}</p>}
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={cerrar}>
          Cancelar
        </Button>
        <Button variant="primary" disabled={!archivo || enviando} onClick={() => onEnviar(archivo, mensaje)}>
          {enviando ? 'Enviando…' : 'Enviar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
